<template>
  <div>
    <v-simple-table fixed-header fixed-footer height="350px" class="elevation-0">
      <template v-slot:default>
        <thead>
          <tr>
            <th style="width: 42px;"></th>
            <th class="text-left">Raw Material Name</th>
            <th class="text-left">Quantity/Weight</th>
            <th class="text-left">Unit Type</th>
            <th class="text-left">Date Added</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in job_order_materials" :key="item.pivot.id" style="cursor: pointer">
            <td>
              <input
                type="checkbox"
                v-model="jobordermaterialsChecked"
                :ref="`job_order_materials${item.pivot.id}`"
                :value="item.pivot.id"
              />
            </td>
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">{{ parseFloat(item.pivot.quantity).toLocaleString() }}</td>
            <td class="text-left">{{ item.unit_type }}</td>
            <td class="text-left">{{ item.created_at }}</td>
          </tr>
          <tr v-if="job_order_materials.length == 0">
            <td colspan="5" style="height:300px;text-align: center">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-card elevation="0">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="jobordermaterialsChecked.length == 0"
          outlined
          color="red"
          @click="deleteRawMaterials"
        >
          DELETE RAW MATERIALS
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import confirm from '../../components/Confirm.vue';

export default {
  props: ['job_order_materials', 'checkbox'],
  data: function() {
    return {
      print: false,
      jobordermaterialsChecked: []
    };
  },
  components: {
    confirm
  },
  methods: {
    ...mapActions([]),
    deleteRawMaterials() {
      this.$refs.confirm
        .open(
          'Delete Job Order Raw Materials',
          'Are you sure you want to delete job order raw materials?',
          { color: '#f44336' }
        )
        .then(confirm => {
          axios
            .delete(`api/v1/joborder/${this.$route.params.id}/deleterawmaterials`, {
              params: { jobordermaterialids: this.jobordermaterialsChecked }
            })
            .then(response => {
              console.log(response.data);
              this.$store.commit('SET_SNACK_BAR', {
                message: 'Raw Materials deleted...',
                color: 'success'
              });
              this['JobOrder/fetchJobOrders']({ page: this.page });
              //this['JobOrder/getJobOrder']({ id: this.$route.params.id });
              this.$router.push('/joborder');
            })
            .catch(response => {
              this.errorMessages = response.response.data.errors;
            })
            .finally(() => {});
        });
    }
  }
};
</script>
